"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeIcon = exports.BannerDismissButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var _ursaIcons = require("@smartsheet/ursa-icons");
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../theme/utils/useTheme");
var _BannerDismissButtonStyled = require("../styled/BannerDismissButtonStyled");
const closeIcon = (0, _sdsThemeInternal.themed)({
  icon: {
    "lodestar-light": /*#__PURE__*/_react.default.createElement(_lodestarIcons.CloseIcon, {
      size: "small",
      color: "currentColor"
    }),
    "ursa-light": /*#__PURE__*/_react.default.createElement(_ursaIcons.CloseIcon, {
      size: 24,
      color: "currentColor"
    })
  }
});
exports.closeIcon = closeIcon;
const BannerDismissButton = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(_BannerDismissButtonStyled.BannerDismissButtonStyled, (0, _extends2.default)({
    tabIndex: 0,
    ref: ref
  }, props), closeIcon.icon(themeMode));
});
exports.BannerDismissButton = BannerDismissButton;
BannerDismissButton.displayName = "BannerDismissButton";
//# sourceMappingURL=BannerDismissButton.js.map